const createdAtFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
});
export const createPromoCodeUsageColumns = () => [
    {
        key: 'user',
        header: 'User',
        sortable: true,
        render: (usage) => usage.user || 'N/A',
    },
    {
        key: 'clinic',
        header: 'Clinic',
        sortable: true,
        render: (usage) => usage.clinic || 'N/A',
    },
    {
        key: 'promo_code',
        header: 'Promo Code',
        sortable: true,
        render: (usage) => usage.promo_code || 'N/A',
    },
    {
        key: 'discount_applied',
        header: 'Discount Applied',
        sortable: true,
        render: (usage) => {
            const amount = parseFloat(String(usage.discount_applied)) || 0;
            return `$${amount.toFixed(2)}`;
        },
    },
    {
        key: 'order',
        header: 'Order',
        sortable: true,
        render: (usage) => usage.order || 'N/A',
    },
    {
        key: 'created_at',
        header: 'Created At',
        sortable: true,
        render: (usage) => {
            if (usage.created_at_display)
                return usage.created_at_display;
            if (!usage.created_at)
                return 'N/A';
            return createdAtFormatter.format(new Date(usage.created_at));
        },
    },
];
